export const CHANGE_PULS_CUSTOMER_REQUEST = "CHANGE_PULS_CUSTOMER_REQUEST";
export const CHANGE_PULS_CUSTOMER_RESULT = "CHANGE_PULS_CUSTOMER_RESULT";
export const CHANGE_PULS_CUSTOMER_OPEN_MODAL = "CHANGE_PULS_CUSTOMER_OPEN_MODAL";
export const CHANGE_PULS_CUSTOMER_CLOSE_MODAL = "CHANGE_PULS_CUSTOMER_CLOSE_MODAL";
export const CHANGE_PULS_CUSTOMER_GET_DEVICE_REQUEST = "CHANGE_PULS_CUSTOMER_GET_DEVICE_REQUEST";
export const CHANGE_PULS_CUSTOMER_GET_DEVICE_RESULT = "CHANGE_PULS_CUSTOMER_GET_DEVICE_RESULT";
export const CHANGE_PULS_CUSTOMER_SET_DEVICE = "CHANGE_PULS_CUSTOMER_SET_DEVICE";
export const CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_REQUEST = "CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_REQUEST";
export const CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_RESULT = "CHANGE_PULS_CUSTOMER_SEARCH_ACCOUNTS_CTC_RESULT";

export const CHANGE_PULS_UPDATE_ACCOUNT_REQUEST = "CHANGE_PULS_UPDATE_ACCOUNT_REQUEST";

